module.exports = __webpack_public_path__ + "static/no-image-house-5b872f2101a4bd6db43f0fed484b0f74.png";